const Test = () => {
  return (
    <>
      {/* <div class="wrp">
   <div class="welcome">
   <h2>W</h2>
   <h2>E</h2>
   <h2>L</h2>
   <h2>C</h2>
   <h2>O</h2>
   <h2>M</h2>
   <h2>E</h2>
   
   </div>
   <div class="to">
       <h2>T</h2>
       <h2>0</h2>
   </div>
   </div> */}

      <div className="wrp2">
        <div className="name">
          <h2>M</h2>
          <h2>A</h2>
          <h2>Y</h2>
          <h2>A 's</h2>
        </div>
        <div className="portfolio">
          <h2>P</h2>
          <h2>O</h2>
          <h2>R</h2>
          <h2>T</h2>
          <h2>F</h2>
          <h2>O</h2>
          <h2>L</h2>
          <h2>I</h2>
          <h2>O</h2>
        </div>
      </div>
    </>
  );
};

export default Test;
